import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .panel {
    width: 100%;
    margin-bottom: 3rem;
  }

  .panel .label {
    ${common.t2}
    color: ${colors.yellow};
    text-align: left;
    background-color: transparent;
    cursor: pointer;
  }

  .panel .content {
    overflow: hidden;
    transition: height .3s ease;
  }

  .panel .inner {
    padding-top: 1.5rem;
    ${common.small}
    line-height: 22px;
  }

  .panel .heading {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .panel .close {
    position: relative;
    width: 2.8rem;
    height: 2.8rem;
    margin-top: .6rem;
    background-color: transparent;
    flex-shrink: 0;
    cursor: pointer;
  }

  .panel .close::before,
  .panel .close::after {
    content: '';
    width: 1.5rem;
    height: 1.5px;
    background-color: ${colors.yellow};
    position: absolute;
    top: 50%;
    left: 50%;
    transition: transform .3s ease;
  }

  .panel .close::before {
    transform: translateX(-50%) rotate(-90deg);
  }

  .panel .close::after {
    transform: translateX(-50%);
  }

  .panel .close.open::before {
    transform: translateX(-50%) rotate(0deg);
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .panel {
      margin-bottom: 1.5rem;
    }
  }
`
